export enum RouteSegments {
	IdPID = 'IdP',
	Method = 'method',
	StepNum = 'stepNum',
	Guide = 'guide'
}

export const ROUTES = {
	home: '/',
	guideNotFound: '/configure/404',
	selectIdP: '/configure/sso/select-idp',
	mapping: `/configure/:${RouteSegments.Guide}/:${RouteSegments.IdPID}/:${RouteSegments.Method}/mapping`,
	testing: `/configure/:${RouteSegments.Guide}/:${RouteSegments.IdPID}/:${RouteSegments.Method}/test`,
	selectScim: '/configure/scim/select-idp',
	selectXaa: '/configure/xaa/select-idp',
	guideStep: `/configure/:${RouteSegments.Guide}/:${RouteSegments.IdPID}/:${RouteSegments.Method}/guide/:${RouteSegments.StepNum}`,
	jit: '/configure/jit',
	unauthorized: '/unauthorized'
};
